import { Modal } from "antd";
const CustomerConfirmation = ({
  isOpen,
  onOk,
  onCancel,
  ReasonText,
  MessageText,
}) => {
  return (
    <>
      <Modal
        title={ReasonText}
        centered
        open={isOpen}
        onCancel={onCancel}
        onOk={onOk}
        width={400}
        okText="Yes"
        cancelText="No"
      >
        <h2 className="text-sm font-normal mb-5">{MessageText}</h2>
      </Modal>
    </>
  );
};
export default CustomerConfirmation;
